import { FernSandbox } from './components/FernSandbox';
import React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas, faGear } from '@fortawesome/free-solid-svg-icons'
import { ThemeProvider } from './contexts/ThemeContext';


library.add(fas, faGear)



function App() {
  return (
    <ThemeProvider>
      <FernSandbox />
    </ThemeProvider>
  );
}

export default App;
